import { API_AXIOS } from "../http/interceptor";
import Apis from "./apis";

export const isMediaReference = (value) =>
  typeof value === "string" && value.startsWith("media:");

export const resolveMediaUrls = async (references) => {
  const values = [...new Set((references || []).filter(Boolean))];
  const mediaReferences = values.filter(isMediaReference);
  const resolved = Object.fromEntries(values.map((value) => [value, value]));

  if (mediaReferences.length === 0) return resolved;

  const { data } = await API_AXIOS.post(Apis.mediaAccessUrls, {
    references: mediaReferences,
  });
  return { ...resolved, ...(data?.urls || {}) };
};

export const resolveMediaUrl = async (reference) => {
  if (!isMediaReference(reference)) return reference;
  const urls = await resolveMediaUrls([reference]);
  return urls[reference];
};
